import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: null,
};

export const folderIdDetails = createSlice({
  name: "folderId",
  initialState,
  reducers: {
    folderIdDetail: (state, action) => {
        state.value = action.payload;
    },
  },
});
export const { folderIdDetail } = folderIdDetails.actions;

export default folderIdDetails.reducer;
